import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';
const {
 GET_DSN_SUMMARY_REQUEST,
  GET_DSN_SUMMARY_SUCCESS,
  GET_DSN_SUMMARY_FAILURE,
  GET_DSN_SUMMARY_LOADING,
  GET_DSN_SUMMARY_RESET,
} = DashboardConstants;

function* getDsnSummary(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DSN_SUMMARY_LOADING });
    const response = yield call(dashboardServices.getDsnSummary, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_DSN_SUMMARY_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DSN_SUMMARY_FAILURE, payload: error });
  }
}

function* getDsnSummarySaga() {
  yield takeEvery(GET_DSN_SUMMARY_REQUEST, getDsnSummary);
}

export default getDsnSummarySaga;
